import { render, staticRenderFns } from "./announcements.vue?vue&type=template&id=c542774a&scoped=true"
import script from "./announcements.vue?vue&type=script&lang=js"
export * from "./announcements.vue?vue&type=script&lang=js"
import style0 from "./announcements.vue?vue&type=style&index=0&id=c542774a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c542774a",
  null
  
)

export default component.exports